<div class="main-header" *ngIf="rewards.headers[0].priority === 1">
  <p
    *ngIf="rewards.headers[0].heading"
    [ngClass]="rewards.headers[0]?.classes?.headingClass"
  >
    {{ rewards.headers[0].heading }}
  </p>
  <p *ngIf="rewards.headers[0].subHeading" [innerHTML]="rewards.headers[0].subHeading | safeHtml: 'html'" [ngClass]="rewards.headers[0]?.classes?.subHeadingClass">
  </p>
</div>
<div class="card-box">
  <div class="card-box-back"></div>
  <ng-container *ngFor="let header of rewards.headers">
    <div class="reward-card" *ngIf="header.priority !== 1">
      <p
        class="reward-card-heading"
        *ngIf="header.heading"
        [ngClass]="header?.classes?.headingClass"
      >
        {{ header.heading }}
      </p>
      <hr
        *ngIf="header.hasHorizontalRow"
        [ngClass]="header?.classes?.hrClass"
      />
      <div [ngClass]="header?.classes?.imageClass">
        <img
          [src]="
            (header?.imageEn)[0]?.file?.publicUrl ||
              (header?.imageFr)[0]?.file?.publicUrl | safeHtml: 'url'
          "
          [alt]="(header?.imageEn)[0]?.name || (header?.imageFr)[0]?.name"
        />
      </div>
      <p class="reward-card-eligibility">{{ header.eligibility }}</p>

      <button class="show-button" (click)="expandPanel($event, expansionPanel)">
        {{ header.priority === 2 ? 'SHOW LESS' : 'LEARN MORE' }}
      </button>

      <div
        #expansionPanel
        [ngClass]="header.priority === 2 ? 'expand-div' : 'collapse-div'"
        style="transition: display 5s;"
        class="expanded-block"
      >
        <ng-container *ngFor="let row of rewards.rows">
          <div
            class="category-label"
            *ngIf="row.showCategoryLabel && !isArray(row); else categoryItem"
          >
            {{ row.label }}
          </div>
          <ng-template #categoryItem>
            <ng-container *ngFor="let data of row; index as columnIndex">
              <div
                class="category-feild"
                *ngIf="
                  data.rewardType.priority === header.priority &&
                  data.showInTablet &&
                  data.value === 'check'
                  && data.percentageValue !== 'N/A'
                "
              >
                {{ getChangedString(data.key, data.percentageValue) }}
              </div>
            </ng-container>
          </ng-template>
        </ng-container>
        <div class="footer-text">
          <p [innerHTML]="rewards.rewardsFooter | safeHtml: 'html'"></p>
        </div>
      </div>
    </div>
  </ng-container>
</div>
